function ellipseText(containerWidth, firstChildNode, targetToEllipseNode, ellipsis) {
  const childWidth = firstChildNode.offsetWidth;
  const txtWidth = targetToEllipseNode.offsetWidth;
  const targetWidth = childWidth > txtWidth ? childWidth : txtWidth;
  if (targetWidth > containerWidth) {
    const text = targetToEllipseNode.textContent ?? "";
    const textChars = text.length;
    const avgLetterSize = txtWidth / textChars;
    const canFit = (containerWidth - (targetWidth - txtWidth)) / avgLetterSize;
    const delEachSide = (textChars - canFit + ellipsis.length) / 2;
    const endLeft = Math.max(Math.floor(textChars / 2 - delEachSide), 0);
    const startRight = Math.ceil(textChars / 2 + delEachSide);
    if (text) {
      targetToEllipseNode.setAttribute("data-original", text);
    } else {
      targetToEllipseNode.removeAttribute("data-original");
    }
    targetToEllipseNode.innerHTML = `${text.slice(
      0,
      endLeft
    )}<span data-testid="ellipsis" class="ellipsis">${ellipsis}</span>${text.slice(startRight)}`;
  }
}
export {
  ellipseText
};
//# sourceMappingURL=ellipseText.js.map
